import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["moduleId", "children", "as", "verticalPositioning", "popoverPlacement", "showIndicator", "iconPosition", "iconProps", "renderCommentIndicator", "outlineRadius", "ctaUrl", "description", "userInfo"];
import { c as _c } from "react-compiler-runtime";
import useCollaborationSidebarState from 'collaboration-sidebar/hooks/useCollaborationSidebarState';
import ControlledCommentableArea from './ControlledCommentableArea';
import { jsx as _jsx } from "react/jsx-runtime";
function CommentableArea(t0) {
  "use memo";

  const $ = _c(33);
  let as;
  let children;
  let ctaUrl;
  let description;
  let iconPosition;
  let iconProps;
  let moduleId;
  let outlineRadius;
  let popoverPlacement;
  let propsForWrapper;
  let renderCommentIndicator;
  let showIndicator;
  let userInfo;
  let verticalPositioning;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      moduleId,
      children,
      as,
      verticalPositioning,
      popoverPlacement,
      showIndicator,
      iconPosition,
      iconProps,
      renderCommentIndicator,
      outlineRadius,
      ctaUrl,
      description,
      userInfo
    } = _t);
    propsForWrapper = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = as;
    $[2] = children;
    $[3] = ctaUrl;
    $[4] = description;
    $[5] = iconPosition;
    $[6] = iconProps;
    $[7] = moduleId;
    $[8] = outlineRadius;
    $[9] = popoverPlacement;
    $[10] = propsForWrapper;
    $[11] = renderCommentIndicator;
    $[12] = showIndicator;
    $[13] = userInfo;
    $[14] = verticalPositioning;
  } else {
    as = $[1];
    children = $[2];
    ctaUrl = $[3];
    description = $[4];
    iconPosition = $[5];
    iconProps = $[6];
    moduleId = $[7];
    outlineRadius = $[8];
    popoverPlacement = $[9];
    propsForWrapper = $[10];
    renderCommentIndicator = $[11];
    showIndicator = $[12];
    userInfo = $[13];
    verticalPositioning = $[14];
  }
  let t1;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      allowNoContext: true
    };
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  const {
    collaborationSidebarState,
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState(t1);
  let t2;
  if ($[16] !== as || $[17] !== children || $[18] !== collaborationSidebarState || $[19] !== ctaUrl || $[20] !== description || $[21] !== iconPosition || $[22] !== iconProps || $[23] !== moduleId || $[24] !== onUpdateCollaborationSidebarState || $[25] !== outlineRadius || $[26] !== popoverPlacement || $[27] !== propsForWrapper || $[28] !== renderCommentIndicator || $[29] !== showIndicator || $[30] !== userInfo || $[31] !== verticalPositioning) {
    t2 = /*#__PURE__*/_jsx(ControlledCommentableArea, Object.assign({
      moduleId: moduleId,
      as: as,
      verticalPositioning: verticalPositioning,
      popoverPlacement: popoverPlacement,
      collaborationSidebarState: collaborationSidebarState,
      onUpdateCollaborationSidebarState: onUpdateCollaborationSidebarState,
      showIndicator: showIndicator,
      iconPosition: iconPosition,
      iconProps: iconProps,
      renderCommentIndicator: renderCommentIndicator,
      outlineRadius: outlineRadius,
      ctaUrl: ctaUrl,
      description: description,
      userInfo: userInfo
    }, propsForWrapper, {
      children: children
    }));
    $[16] = as;
    $[17] = children;
    $[18] = collaborationSidebarState;
    $[19] = ctaUrl;
    $[20] = description;
    $[21] = iconPosition;
    $[22] = iconProps;
    $[23] = moduleId;
    $[24] = onUpdateCollaborationSidebarState;
    $[25] = outlineRadius;
    $[26] = popoverPlacement;
    $[27] = propsForWrapper;
    $[28] = renderCommentIndicator;
    $[29] = showIndicator;
    $[30] = userInfo;
    $[31] = verticalPositioning;
    $[32] = t2;
  } else {
    t2 = $[32];
  }
  return t2;
}
export default CommentableArea;